/** @format */

import {ReactNode} from 'react';

import IconCategorySeasonality from '../assets/IconCategorySeasonality';
import IconCategoryWeather from '../assets/IconCategoryWeather';
import {ChartIds} from '../models/chartIds';

const getCategoryIcon = (chartId: ChartIds): ReactNode | null => {
  switch (chartId) {
    case 'stub_weather':
      return <IconCategoryWeather />;
    case 'stub_seasonality':
      return <IconCategorySeasonality />;
    default:
      return null;
  }
};

export default getCategoryIcon;
